// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.login-container {
    background-color: var(--darkGreen);
    overflow: hidden;
    min-height: 100vh;
    padding: 40px;
}

 .login-main {
    min-height: calc(100vh - 80px);
    background-color: var(--lightBlack);
    display: flex;
    flex-wrap: wrap;
    padding: 20px;
    border-radius: 2.5rem;
}

.login-container .login-main .left-section {
    text-align: center;
    position: relative;
    width: 50%;
}

.login-container .login-main .left-section .img-container {
    position: relative;
    display: inline-block;
}

.login-container .login-main .left-section .img-container img {
    max-height: calc(100vh - 130px);
    height: 100%;
    width: 100%;
    object-fit: contain;
    object-position: left;
}

.login-container .login-main .right-section {
    width: 50%;
    max-width: 500px;
    margin: 0 auto;
    padding: 0 2rem;
}
.login-main .right-section .heading--box,
.login-main .right-section .heading--box h2 {
    margin-bottom: 1rem;
}
.login-main .right-section .logo-box {
    margin: 7rem 0 4rem 0;
}
.login-container .login-main .left-section .heading {
    color: var(--darkGreen);
    font-size: clamp(32px, 2vw, 48px);
    font-weight: bold;
    text-align: left;
}

.login-container .login-main .left-section .text-container {
    position: absolute;
    bottom: 6%;
    left: 7%;
} 

.login-details h2 {
    font-size: 40px;
    line-height: 1.5;
    font-weight: 400;
}
.right-section form {
    display: block;
}
.login-main .right-section form > div{
    width: 100%;
}
.remember-label{
    font-size: 12px;
    margin-left: 5px;
}
.pass-btn-group  .MuiOutlinedInput-root {
    padding: 0;
}
.pass-btn-group .MuiInputBase-root input {
    border-right: 0;
    border-radius: 4px 0 0 4px;
}
.pass-btn-group .MuiInputAdornment-positionEnd {
    height: 100%;
    padding: 0;
    margin: 0;
}
.pass-btn-group .MuiInputAdornment-positionEnd button.MuiButtonBase-root {
    
    color: var(--whiteLight);
    border-radius: 0 4px 4px 0;
    background-color: #062a37;
}
.pass-btn-group .MuiInputBase-root{
    background-color: var(--darkGreen);
    color: var(--white);
}
/* OTP CSS START */
.otp-wrapper{
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 1rem;
}
  
.otp-wrapper input{
    margin: 5px;
    border: none;
    border-bottom: 2px solid var(--primeryColor);
    color: var(--primeryColor);
    background-color: transparent;
    outline: 0;
    font-size: 16px;
    line-height: 2.5;
    font-family: 'Acumin Pro';
    font-weight: 400;
}

input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
}

input[type=number] {
    -moz-appearance: textfield;
}
.otp-wrapper .input-box .input-wrap {
    border: none;
}
/* OTO CSS END */`, "",{"version":3,"sources":["webpack://./src/Screens/Login/Login.css"],"names":[],"mappings":"AAAA;IACI,kCAAkC;IAClC,gBAAgB;IAChB,iBAAiB;IACjB,aAAa;AACjB;;CAEC;IACG,8BAA8B;IAC9B,mCAAmC;IACnC,aAAa;IACb,eAAe;IACf,aAAa;IACb,qBAAqB;AACzB;;AAEA;IACI,kBAAkB;IAClB,kBAAkB;IAClB,UAAU;AACd;;AAEA;IACI,kBAAkB;IAClB,qBAAqB;AACzB;;AAEA;IACI,+BAA+B;IAC/B,YAAY;IACZ,WAAW;IACX,mBAAmB;IACnB,qBAAqB;AACzB;;AAEA;IACI,UAAU;IACV,gBAAgB;IAChB,cAAc;IACd,eAAe;AACnB;AACA;;IAEI,mBAAmB;AACvB;AACA;IACI,qBAAqB;AACzB;AACA;IACI,uBAAuB;IACvB,iCAAiC;IACjC,iBAAiB;IACjB,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,UAAU;IACV,QAAQ;AACZ;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,gBAAgB;AACpB;AACA;IACI,cAAc;AAClB;AACA;IACI,WAAW;AACf;AACA;IACI,eAAe;IACf,gBAAgB;AACpB;AACA;IACI,UAAU;AACd;AACA;IACI,eAAe;IACf,0BAA0B;AAC9B;AACA;IACI,YAAY;IACZ,UAAU;IACV,SAAS;AACb;AACA;;IAEI,wBAAwB;IACxB,0BAA0B;IAC1B,yBAAyB;AAC7B;AACA;IACI,kCAAkC;IAClC,mBAAmB;AACvB;AACA,kBAAkB;AAClB;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,SAAS;AACb;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,4CAA4C;IAC5C,0BAA0B;IAC1B,6BAA6B;IAC7B,UAAU;IACV,eAAe;IACf,gBAAgB;IAChB,yBAAyB;IACzB,gBAAgB;AACpB;;AAEA;;IAEI,wBAAwB;IACxB,SAAS;AACb;;AAEA;IACI,0BAA0B;AAC9B;AACA;IACI,YAAY;AAChB;AACA,gBAAgB","sourcesContent":[".login-container {\n    background-color: var(--darkGreen);\n    overflow: hidden;\n    min-height: 100vh;\n    padding: 40px;\n}\n\n .login-main {\n    min-height: calc(100vh - 80px);\n    background-color: var(--lightBlack);\n    display: flex;\n    flex-wrap: wrap;\n    padding: 20px;\n    border-radius: 2.5rem;\n}\n\n.login-container .login-main .left-section {\n    text-align: center;\n    position: relative;\n    width: 50%;\n}\n\n.login-container .login-main .left-section .img-container {\n    position: relative;\n    display: inline-block;\n}\n\n.login-container .login-main .left-section .img-container img {\n    max-height: calc(100vh - 130px);\n    height: 100%;\n    width: 100%;\n    object-fit: contain;\n    object-position: left;\n}\n\n.login-container .login-main .right-section {\n    width: 50%;\n    max-width: 500px;\n    margin: 0 auto;\n    padding: 0 2rem;\n}\n.login-main .right-section .heading--box,\n.login-main .right-section .heading--box h2 {\n    margin-bottom: 1rem;\n}\n.login-main .right-section .logo-box {\n    margin: 7rem 0 4rem 0;\n}\n.login-container .login-main .left-section .heading {\n    color: var(--darkGreen);\n    font-size: clamp(32px, 2vw, 48px);\n    font-weight: bold;\n    text-align: left;\n}\n\n.login-container .login-main .left-section .text-container {\n    position: absolute;\n    bottom: 6%;\n    left: 7%;\n} \n\n.login-details h2 {\n    font-size: 40px;\n    line-height: 1.5;\n    font-weight: 400;\n}\n.right-section form {\n    display: block;\n}\n.login-main .right-section form > div{\n    width: 100%;\n}\n.remember-label{\n    font-size: 12px;\n    margin-left: 5px;\n}\n.pass-btn-group  .MuiOutlinedInput-root {\n    padding: 0;\n}\n.pass-btn-group .MuiInputBase-root input {\n    border-right: 0;\n    border-radius: 4px 0 0 4px;\n}\n.pass-btn-group .MuiInputAdornment-positionEnd {\n    height: 100%;\n    padding: 0;\n    margin: 0;\n}\n.pass-btn-group .MuiInputAdornment-positionEnd button.MuiButtonBase-root {\n    \n    color: var(--whiteLight);\n    border-radius: 0 4px 4px 0;\n    background-color: #062a37;\n}\n.pass-btn-group .MuiInputBase-root{\n    background-color: var(--darkGreen);\n    color: var(--white);\n}\n/* OTP CSS START */\n.otp-wrapper{\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    gap: 1rem;\n}\n  \n.otp-wrapper input{\n    margin: 5px;\n    border: none;\n    border-bottom: 2px solid var(--primeryColor);\n    color: var(--primeryColor);\n    background-color: transparent;\n    outline: 0;\n    font-size: 16px;\n    line-height: 2.5;\n    font-family: 'Acumin Pro';\n    font-weight: 400;\n}\n\ninput::-webkit-outer-spin-button,\ninput::-webkit-inner-spin-button {\n    -webkit-appearance: none;\n    margin: 0;\n}\n\ninput[type=number] {\n    -moz-appearance: textfield;\n}\n.otp-wrapper .input-box .input-wrap {\n    border: none;\n}\n/* OTO CSS END */"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
